import { BookingState } from 'fitbeat.models';
import { BookingsConfig } from '../../config/bookings';
import { UserWorkoutSession } from '../../entities/workoutsession';

export class WorkoutFilter {
    public static FilterNonInvites(dateOfRequest: Date = new Date()):
        (sessions: UserWorkoutSession[]) => UserWorkoutSession[] {

        return ((sessions: UserWorkoutSession[]): UserWorkoutSession[] => {
            return sessions.filter((session: UserWorkoutSession) =>
                WorkoutFilter.isNotRemoved(dateOfRequest, session) &&
                session.bookingState === BookingState.BookingInvite,
            );
        });
    }

    public static FilterRemovedAndProvisional(dateOfRequest: Date = new Date()):
        (sessions: UserWorkoutSession[]) => UserWorkoutSession[] {

        return ((sessions: UserWorkoutSession[]): UserWorkoutSession[] => {
            return sessions.filter((session: UserWorkoutSession) =>
                WorkoutFilter.isNotRemoved(dateOfRequest, session) &&
                session.bookingState === BookingState.ConfirmedBooking,
            );
        });
    }

    public static FilterRemovedAndProvisionalAndNotWithinCheckinTimeFrame(timeOfCheckin: Date = new Date()):
        (sessions: UserWorkoutSession[]) => UserWorkoutSession[] {

        return ((sessions: UserWorkoutSession[]): UserWorkoutSession[] => {
            return sessions.filter((session: UserWorkoutSession) => {
                const timeDiffInMinutes = (timeOfCheckin.getTime() - new Date(session.startTime).getTime()) / 1000 / 60;
                const withinCheckinFrame =
                    timeDiffInMinutes >= -BookingsConfig.maxNumberOfMinutesPriorToExerciseForCheckin &&
                    timeDiffInMinutes <= BookingsConfig.maxNumberOfMinutesAfterExerciseForCheckin;
                return WorkoutFilter.isNotRemoved(timeOfCheckin, session) &&
                    session.bookingState === BookingState.ConfirmedBooking &&
                    withinCheckinFrame;
            });
        });
    }

    public static FilterExpiredNotified(dateOfRequest: Date = new Date()):
        (sessions: UserWorkoutSession[]) => UserWorkoutSession[] {

        return ((sessions: UserWorkoutSession[]): UserWorkoutSession[] => {
            return sessions.filter((session: UserWorkoutSession) => {
                return WorkoutFilter.isNotRemoved(dateOfRequest, session) && !session.expiryNotified;
            });
        });
    }

    public static FilterRemovedAndCheckedIn(dateOfRequest: Date = new Date()):
        (sessions: UserWorkoutSession[]) => UserWorkoutSession[] {

        return ((sessions: UserWorkoutSession[]): UserWorkoutSession[] => {
            return sessions.filter((session: UserWorkoutSession) => {
                return WorkoutFilter.isNotRemoved(dateOfRequest, session) && !session.checkedIn;
            });
        });
    }

    public static FilterRemoved(dateOfRequest: Date = new Date()):
        (sessions: UserWorkoutSession[]) => UserWorkoutSession[] {

        return ((sessions: UserWorkoutSession[]): UserWorkoutSession[] => {
            return sessions.filter((session: UserWorkoutSession) => {
                return WorkoutFilter.isNotRemoved(dateOfRequest, session);
            });
        });
    }

    public static getExcludeWorkoutsDuringWarmdownFilter = (date: Date) => {
        // DISABLED FOR HOME
        // const exludeWorkoutsDuringCurrentWamrupFilter = (bookings: UserWorkoutSession) => {
        //     const endTime = new Date(bookings.endTime);
        //     const timeSlices = new TimeSlices(endTime, 120);
        //     return timeSlices.getPreviousCycle(endTime) > date;
        // };
        // return exludeWorkoutsDuringCurrentWamrupFilter;
        return () => {
            return true;
        };
    }

    private static isNotRemoved(dateOfRequest: Date, session: UserWorkoutSession) {
        // subtle logic: if the removal date is in the future from the date of the request
        // then the removal should not take effect YET and is treated as not removed
        // ensure that the dateOfRequest is correct to avoid strange behaviour
        const isRemovalNotYetInEffect = session.removedAt && session.removedAt.getTime() > dateOfRequest.getTime();
        return (!session.removedAt || isRemovalNotYetInEffect);
    }
}
